"use strict";

class AdminProfileController {
    constructor($element, $parse, $timeout, SSHttpService, SSUtilService, SSAlertService, OTPService, SSUserService, SSConfirmationService, SSAwsService, SSAppService) {
        const self = this;

        self.$element = $element;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;

        self.SMS_SERVICE_TOKEN_SENT_SUCCESSFULLY = SHOWSUITE.SMS_SERVICE_TOKEN_SENT_SUCCESSFULLY; // 1
        self.SMS_SERVICE_TOKEN_WAS_ALREADY_SENT = SHOWSUITE.SMS_SERVICE_TOKEN_WAS_ALREADY_SENT; // 2
        self.SMS_SERVICE_TOKEN_SENT_ERROR = SHOWSUITE.SMS_SERVICE_TOKEN_SENT_ERROR;  // 3
        self.SMS_SERVICE_TOKEN_MISSING_REQUIRED_PARAMS = SHOWSUITE.SMS_SERVICE_TOKEN_MISSING_REQUIRED_PARAMS;  // 4

        self.ASSET_MODEL_SALES_CONSULTANT_SIGNATURE = SHOWSUITE.ASSET_MODEL_SALES_CONSULTANT_SIGNATURE;
        
        self.DEVELOPER_SETTINGS_PASSWORD_VALIDATION = SHOWSUITE.DEVELOPER_SETTINGS_PASSWORD_VALIDATION;
        self.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN = SHOWSUITE.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN;

        self.TYPE_ENABLE_2FA = 1;
        
        self.showImageUri = null;

        let user = self.SSUserService.getUser();
        if (!user) {
            self.SSUserService.showLoginModal();
            return;
        }
        self.user = user;

        self.init();
    }

    init() {
        const self = this;

        self.userParams = {
            user_first_name: self.user.first_name,
            user_last_name: self.user.last_name,
            user_display_name: self.user.display_name,
            user_designation: self.user.designation,
            user_email: self.user.email,
            user_phone1: self.user.phone1,
            user_allowed_ips: self.user.allowed_ips,
        };

        self.maskPhoneNumber(self, 'ctrl.');

        self.user_roles = self.SSUserService.getUserRoles();

        let user_role = self.user_roles.find(x => x.name === self.user.role);

        if (user_role) {
            self.user.role_display_name = user_role.display_name;
        } else {
            self.user.role_display_name = "No role selected";
        }

        if (self.SSUserService.isSuper()) {
            self._setIdAddressField();
        }
        if (self.SSUserService.isDeveloper()) {
            self.getDeveloperSettings();
        }

        self.getSalesConsultant();
    }

    hasViewPermission() {
        const self = this;

        if (self.SSUserService.isDeveloper()) {
            if (self.SSUserService.hasPermission('DMS_VIEW_MY_PROFILE')) {
                return true;
            } else {
                return false;
            }
        } else {
            self.has_access = false;
            if (self.SSUserService.isLawfirm()) {
                self.has_access = true;
            }
            return true;
        }
    }

    hasEditPermission() {
        const self = this;

        if (self.SSUserService.isDeveloper()) {
            if (self.SSUserService.hasPermission('DMS_EDIT_MY_PROFILE')) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    saveUser() {
        const self = this;

        if (self._validationIpRestriction())
            return;
        if (!self.SSUtilService.validateForm(self, 'ctrl', self.$element.find('#MyAccountUserDetails')))
            return;

        self.userErrors = {};
        let params = angular.copy(self.userParams);
        delete params.user_email;

        let url = 'sec/me';

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);

                jQuery.each(response.data, function (key, value) {
                    try {
                        self.userErrors[key] = value[0];
                    } catch (ex) {
                    }
                });

                return;
            }

            self.SSAlertService.success('User details updated successfully.');

            //self.SSUserService.setUser(response.data.user);
            self.userDataUpdate(response.data.user);
            self.init();
        });
    }

    userDataUpdate(updatedUser){
        const self = this;

        self.user.first_name = updatedUser.first_name; ;
        self.user.last_name = updatedUser.last_name;
        self.user.display_name = updatedUser.display_name;
        self.user.designation = updatedUser.designation;
        self.user.phone1 = updatedUser.phone1;
        self.user.allowed_ips = updatedUser.allowed_ips;
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        let parent = jQuery;
        if (formId) {
            parent = jQuery('#' + formId);
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {

                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));
                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    _updateTwoFA() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self.updateTwoFA();
        });
    }

    updateTwoFA() {
        const self = this;

        //WEB-3553: while 2FA is enforced at organisation level the personal toggle is locked
        // (server rejects with 412007 anyway — this just avoids a pointless round-trip)
        if (self.user && parseInt(self.user.twofa_enforced || 0, 10) === 1) {
            return;
        }

        self.twofa_code = '';
        self.errTwoFACode = '';

        //WEB-3578: disabling 2FA now requires step-up re-authentication. The server rejects the
        // disable path of toggle2fa unless the current account password is supplied (sub_code 412008).
        // Collect it via the dedicated modal; enabling is unchanged (still gated by the phone OTP below).
        if (self.user.twofa_enabled) {
            self.showDisable2FAModal();
            return;
        }

        if (!self.user.phone1) {
            self.SSAlertService.danger('Error!', 'Please update your contact number.');
            return;
        }

        loading(true);
        self.SSHttpService.postAPIRequest('sec/me/toggle2fa').then(function (responseObj) {
            loading(false);

            if (responseObj instanceof Error) {

                //WEB-3553: 412007 = locked by org-level enforcement (e.g. enabled after this
                // session's user snapshot was stored) — lock the control and show the real reason
                if (responseObj.sub_code == 412007) {
                    self.user.twofa_enforced = 1;
                    self.SSAlertService.warning('2FA Enforced!', responseObj.message);
                } else if (responseObj.sub_code == self.SMS_SERVICE_TOKEN_SENT_SUCCESSFULLY) {
                    self.showUpdate2FAModal(responseObj);
                } else if (responseObj.sub_code == self.SMS_SERVICE_TOKEN_WAS_ALREADY_SENT) {
                    self.showUpdate2FAModal(responseObj);
                } else if (responseObj.sub_code == self.SMS_SERVICE_TOKEN_SENT_ERROR) {
                    self.SSAlertService.danger('Error!', 'Please update your contact number.');
                    self.showUpdate2FAModal(responseObj);
                } else {
                    self.SSAlertService.parseAndDisplayError(responseObj);
                }
            } else if (self.user.twofa_enabled) {
                self.SSConfirmationService.getConfirmed(
                    'Confirm!',
                    '2FA updated successfully.',
                    self.SSConfirmationService.TYPE_DEFAULT,
                    function () {
                        self.user.twofa_enabled = 0;
                    }
                );
            }
        });
    }

    ipRestrictionCheck(check) {
        const self = this;

        if (check) {
            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                'Are you sure you want to Enable IP restriction?',
                self.SSConfirmationService.TYPE_YES_NO,
                function () {
                    self.IpEnabledCheck = check;
                }
            );
        } else {
            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                'Are you sure you want to Disable IP restriction?',
                self.SSConfirmationService.TYPE_YES_NO,
                function () {
                    self.IpEnabledCheck = check;
                }
            );
        }
    }

    _setIdAddressField() {
        const self = this;
        self.allowedIps = self.userParams.user_allowed_ips;

        if (self.allowedIps) {
            self.IpEnabledCheck = true;
        } else {
            self.IpEnabledCheck = false;
        }
    }

    _validationIpRestriction() {
        const self = this;

        if (self.IpEnabledCheck) {

            if (self.allowedIps) {

                if (self.allowedIps.length <= 255) {
                    self.userParams.user_allowed_ips = self.allowedIps;
                    self.errIpRestriction = '';
                    return false;
                } else {
                    self.errIpRestriction = 'Max Limit 255 characters';
                    return true;
                }

            } else {
                self.errIpRestriction = 'Please Enter IP Address or Disable the IP Restriction.';
                return true;
            }
        } else {
            self.userParams.user_allowed_ips = '';
            self.allowedIps = '';
            return false;
        }
    }

    showUpdate2FAModal(response) {
        const self = this;

        self.prefix_2fa = (response.data && response.data.prefix_2fa) ? response.data.prefix_2fa : '';
        self.hideModals();
        self.showModal = true;
        $('#updateTwoFAModal').modal('show');
    }

    /**
     * WEB-4441: whether disabling 2FA needs the current-password step-up (WEB-3578).
     *
     * The server reports `twofa_disable_requires_password` on the user payload: 0 for single
     * sign-on users whose Showsuite password login is blocked — they have no password, and
     * toggle2fa skips the step-up for them (WEB-3780). A missing flag (older API, or a session
     * snapshot taken before it existed) keeps the password step-up, i.e. today's behaviour.
     *
     * @returns {boolean} true = show and require the password field.
     * @remarks UX-only — the server enforces the same rule; see sec/me/toggle2fa.
     */
    disable2FARequiresPassword() {
        const self = this;

        if (!self.user || typeof self.user.twofa_disable_requires_password === 'undefined' || self.user.twofa_disable_requires_password === null) {
            return true;
        }
        return parseInt(self.user.twofa_disable_requires_password, 10) !== 0;
    }

    //WEB-3578: open the password step-up modal used to disable 2FA.
    showDisable2FAModal() {
        const self = this;

        self.disable2fa_password = '';
        self.errDisable2faPassword = '';
        self.hideModals();
        self.showDisable2faModal = true;
        $('#disableTwoFAModal').modal('show');
    }

    //WEB-3578: confirm the 2FA disable by re-authenticating with the current account password.
    confirmDisable2FA() {
        const self = this;

        self.errDisable2faPassword = '';

        //WEB-4441: SSO-only users have no password — skip the check and post without it
        let requiresPassword = self.disable2FARequiresPassword();

        if (requiresPassword && !self.disable2fa_password) {
            self.errDisable2faPassword = 'Please enter your current password.';
            return;
        }

        let params = requiresPassword ? {user_current_password: self.disable2fa_password} : null;

        loading(true);
        self.SSHttpService.postAPIRequest('sec/me/toggle2fa', params).then(function (responseObj) {
            loading(false);

            if (responseObj instanceof Error) {
                //412008 = missing/incorrect password, 412009 = too many attempts (locked out) — keep the modal open
                if (responseObj.sub_code == 412008 || responseObj.sub_code == 412009) {
                    //WEB-4441: the server still wants a password (SSO turned off since the flag was read) — show the field
                    if (!requiresPassword) {
                        self.user.twofa_disable_requires_password = 1;
                    }
                    self.errDisable2faPassword = responseObj.message || 'Unable to disable 2FA. Please try again.';
                } else if (responseObj.sub_code == 412007) {
                    //org-level enforcement turned on meanwhile — lock the control and surface the reason
                    self.user.twofa_enforced = 1;
                    self.hideModals();
                    self.SSAlertService.warning('2FA Enforced!', responseObj.message);
                } else {
                    self.SSAlertService.parseAndDisplayError(responseObj);
                }
                return;
            }

            self.disable2fa_password = '';
            self.hideModals();
            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                '2FA disabled successfully.',
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    self.user.twofa_enabled = 0;
                }
            );
        });
    }

    verifyTwoFA() {
        const self = this;

        self.errTwoFACode = '';

        let params = {
            email: self.user.email,
            twofa_code: self.prefix_2fa + self.twofa_code,
            twofa_type: self.TYPE_ENABLE_2FA
        };

        loading(true);
        self.SSHttpService.postAPIRequest('2fa', params).then(function (responseObj) {
            loading(false);
            if (responseObj instanceof Error) {
                self.SSAlertService.parseAndDisplayError(responseObj);

                self.errTwoFACode = "Invalid Code";
                return;
            }

            self.hideModals();

            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                '2FA updated successfully.',
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    self.user.twofa_enabled = 1;
                }
            );
        });
    }

    hideModals() {
        const self = this;

        self.showModal = false;
        self.showCropPhotoModalPopUp = false;
        self.showDisable2faModal = false;

        if ($('#updateTwoFAModal').is(':visible')) $('#updateTwoFAModal').modal('hide');
        if ($('#disableTwoFAModal').is(':visible')) $('#disableTwoFAModal').modal('hide');
        if ($('#cropPhotoModalPopUp').is(':visible')) $('#cropPhotoModalPopUp').modal('hide');
    }

    uploadSignatureFile(files) {
        const self = this;

        if (!files || files.length < 1) return;

        if (!self.userParams.sales_consultants_code) {
            self.SSAlertService.danger("Error!", "Please enter staff id before uploading the signature file.");
            return;
        }

        let file = files[0];
        self.file_name = file.name;

        if (URL) {
            self.displayCropPhotoModal(URL.createObjectURL(file));
        } else if (FileReader) {
            let reader = new FileReader();
            reader.onload = function (e) {
                self.displayCropPhotoModal(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    displayCropPhotoModal(url) {
        const self = this;

        self.hideModals();

        self.beforeCropImgUrl = angular.copy(url);

        self.showCropPhotoModalPopUp = true;
        $('#cropPhotoModalPopUp').modal('show');
    }

    _uploadSignatureFile(file_uri, is_remove) {
        const self = this;

        let url = 'sec/developer/profile/sales-consultant';
        let params = {
            code: self.userParams.sales_consultants_code,
            signature_file_uri: file_uri
        };
        loading(true);

        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (is_remove) {
                self.SSAlertService.success('Success!', 'File removed successfully.');
            } else {
                self.SSAlertService.success('Success!', 'File uploaded successfully.');
            }

            if (response.data.sales_consultant.signature_file_uri) {
                self.userParams.sales_consultants_signature_file_uri = response.data.sales_consultant.signature_file_uri;
                self.accessSignatureFile(response.data.sales_consultant.id);
            } else {
                self.userParams.sales_consultants_signature_file_uri = null;
                self.showImageUri = null;
            }
        });
    }

    getSalesConsultant() {
        const self = this;

        let url = 'sec/me';
        let params = {
            include: 'sales_consultant'
        };
        loading(true);

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //WEB-3553: self.user is the session snapshot captured at login — org-level
            // enforcement may have changed since, so sync the live flag from sec/me here
            // (this page already makes the call) so the 2FA lock reflects the current state.
            if (response.data.user && typeof response.data.user.twofa_enforced !== 'undefined') {
                self.user.twofa_enforced = response.data.user.twofa_enforced;
            }
            //WEB-4441: same for the Disable 2FA password requirement (0 = SSO-only, no password)
            if (response.data.user && typeof response.data.user.twofa_disable_requires_password !== 'undefined') {
                self.user.twofa_disable_requires_password = response.data.user.twofa_disable_requires_password;
            }

            if (response.data.sales_consultant) {
                if (response.data.sales_consultant.signature_file_uri) {
                    self.accessSignatureFile(response.data.sales_consultant.id);
                }
                self.userParams.sales_consultants_signature_file_uri = response.data.sales_consultant.signature_file_uri;
                self.userParams.sales_consultants_code = response.data.sales_consultant.code;
            }
        });
    }

    accessSignatureFile(signature_id) {
        const self = this;

        let url = 'sec/assets/presigned-url';
        let params = {
            model: self.ASSET_MODEL_SALES_CONSULTANT_SIGNATURE,
            id: signature_id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (responseObj) {
            loading(false);
            if (responseObj instanceof Error) {
                self.SSAlertService.parseAndDisplayError(responseObj);
                return;
            }
            self.showImageUri = responseObj.data.presigned_url;
        });
    }

    removeSignatureFile() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Remove the signature file?',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                self._uploadSignatureFile('', true);
            }
        );
    }

    cropImage() {
        const self = this;

        let canvas = SHOWSUITE.cropper.getCroppedCanvas();

        canvas.toBlob(function (file) {
            file.name = self.file_name;

            let policyUrl = 'sec/developer/profile/sales-consultant/s3-policy-document';

            loading(true);
            self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.hideModals();
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self._uploadSignatureFile(response.config.data.key);
            });
        });
    }

    getDeveloperSettings() {
        const self = this;

        let url = 'sec/developer/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.developer_settings) {
                self.SSUserService.password_validation = response.data.developer_settings.some(x => x.name == self.DEVELOPER_SETTINGS_PASSWORD_VALIDATION)? self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_PASSWORD_VALIDATION).value: null;

                let passwordBasedLoginSetting = self.getSetting(response.data.developer_settings, self.DEVELOPER_SETTINGS_PASSWORD_BASED_LOGIN);
                self.SSUserService.password_based_login_disabled = !!(passwordBasedLoginSetting && passwordBasedLoginSetting.value && passwordBasedLoginSetting.value.disabled);
            }
        });
    }

    getSetting(settings, setting_name) {
        const self = this;

        if (!(settings && setting_name)) {
            return null;
        }

        let setting = {};

        try {
            setting = settings.find(x => x.name == setting_name);

            if (setting
                && setting.value
                && typeof setting.value == "string"
            ) {
                setting.value = JSON.parse(setting.value);
            }
        } catch (ex) {
            console.log(ex);
        }

        return setting;
    }

}

AdminProfileController.$inject = ['$element', '$parse', '$timeout', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSConfirmationService', 'SSAwsService', 'SSAppService'];
app.controller('AdminProfileController', AdminProfileController);
